export const OFFER_FINANCIAL_FEES_CATALOG_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFinancialFeesCatalogUpdated";
export const OFFER_FINANCIAL_FEES_CATALOG_NEGOTIATION_DATA_RETRIEVED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFinancialFeesCatalogNegotiationDataRetrieved";
export const OFFER_FEES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.OfferFeesInvalidated";
export const OFFER_FEE_APPROVAL1_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.LeasingIncomeSchemaApproval1Updated";
export const OFFER_FEE_APPROVAL2_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Financials.LeasingIncomeSchemaApproval2Updated";
